import { initNavLogout, initNavigation } from "./shared/nav/nav";

let navInited = false;

export const app = {
    modal: {
        open: (id: string) => {
            $(`#${id}`).modal("show");
        }
    },
    init() {
        if (navInited) return;
        navInited = true;

        initNavLogout();
        initNavigation();
    }
};

declare global {
    interface Window { app: typeof app }
}

window.app = app;

$(function () {
    app.init();
});